import {
  ACTIVITY_SENSOR_HISTORY_REQUEST,
  ACTIVITY_SENSOR_HISTORY_SUCCESS,
  ACTIVITY_SENSOR_HISTORY_ERROR
} from '../utils/app_constants';

const ACTIVITY_SENSOR_HISTORY_INITIAL_STATE = {};

export const activitySensorHistoryReducer = (
  state = ACTIVITY_SENSOR_HISTORY_INITIAL_STATE,
  action
) => {
  switch (action.type) {
    case ACTIVITY_SENSOR_HISTORY_REQUEST:
      return {
        ...state,
        [action.deviceId]: {
          payload: {},
          isLoading: true,
          hasError: false
        }
      };
    case ACTIVITY_SENSOR_HISTORY_SUCCESS:
      return {
        ...state,
        [action.deviceId]: {
          isLoading: false,
          hasError: false,
          payload: { ...action.payload }
        }
      };
    case ACTIVITY_SENSOR_HISTORY_ERROR:
      return {
        ...state,
        [action.deviceId]: {
          isLoading: false,
          hasError: true,
          payload: { ...action.payload }
        }
      };
    default:
      return state;
  }
};
